import { render, staticRenderFns } from "./MessageSnackbar.vue?vue&type=template&id=63e91376&scoped=true&"
import script from "./MessageSnackbar.vue?vue&type=script&lang=js&"
export * from "./MessageSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./MessageSnackbar.vue?vue&type=style&index=0&id=63e91376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e91376",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
